import linq from 'linq'
import Color from '../models/Color';
import Size from '../models/Size';
import { camelToSnake, snakeToCamel } from '../utility/stringUtility'
import ItemImage from '../models/ItemImage';
import Category from "../models/Category";

const FILLABEL = [
]

export default class ProductDetailViewModel {

    constructor (data = null) {
        this.originalData = data

        this.id = 0
        this.name = ''
        this.description = ''
        this.stock = 0
        this.hasSubs = false
        this.mains = []
        this.subs = []
        this.images = null
        this.icons = []
        this.product =[]

        if (data) {
            this.create(data)
        }
    }

    get _model () {
        return 'ProductDetailViewModel'
    }

    get data () {
        return this.originalData
    }

    create (data) {
        const resource = this.eval(data)

        linq.from(resource.product)
            .select(x => {
                x.key = camelToSnake(x.key)
                return x
            })
            .where(x => this.hasOwnProperty(snakeToCamel(x.key)))
            .select(x => {
                const key = snakeToCamel(x.key)

                if (typeof this[key] === 'number') {
                    this[key] = Number(x.value)
                    return
                }

                if (key === 'mains') {
                    this[key] = this.colorOrSize(x.value)
                    return
                }

                if (key === 'subs') {
                    this[key] = this.colorOrSize(x.value)
                    return
                }

                if (key === 'images') {
                    const images = linq.from(x.value).select(x => new ItemImage(x)).toArray()
                    this[key] = this.createImage(images)
                    return
                }

                this[key] = x.value
                return x
            })
            .toArray()
        return this
    }

    createImage (data) {
        const images = linq.from(data)
            .select(x => {
                return {
                    id: x.id,
                    url: x.path,
                    imgName: x.imgName
                }
            })
            .toArray()

        return {
            thumbs: this.changeUrl(JSON.parse(JSON.stringify(images)), 'thumb'),
            normal_size: images,
            large_size: this.changeUrl(JSON.parse(JSON.stringify(images)), 'large')
        }
    }

    changeUrl (images, type) {
        return linq.from(images)
            .select(x => {
                x.url = x.url.replace(/normal/, type)
                return x
            })
            .toArray()
    }

    colorOrSize (data) {
        if (linq.from(data).any(x => x.color)) {
            return linq.from(data).select(x => new Color(x)).toArray()
        } else {
            return linq.from(data).select(x => new Size(x)).toArray()
        }
    }

    eval (data) {
        if (typeof data === 'string') {
            return eval(data)
        } else {
            return data
        }
    }

    getPostable () {
        return linq.from(this)
            .where(x => linq.from(FILLABEL).any(xs => xs === x.key))
            .where(x => x.value)
            .select(x => {
                return {
                    key: camelToSnake(x.key),
                    value: x.value
                }
            })
            .toObject('$.key', '$.value')
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/viewModel/ProductDetailViewModel.js